import { toast } from 'sonner';
import { mention, pink2, successTint } from '../../../../../../../web/styles/colors';
import { IEventSurveyResponse } from '../../../../../../models/Api';
export { buildCustomPropertiesSchema } from '../../../../../../utils/validation';

export const areGuestNamesValid = ({ firstName, lastName }: { firstName?: string; lastName?: string }): boolean => {
	// If both are empty, it's valid
	if (!firstName && !lastName) return true;
	// Only one provided: invalid
	if (!firstName || !lastName) return false;
	// Both provided: check that trimmed values exist
	return !!firstName.trim() === !!lastName.trim();
};

export const handleMutationSuccess = ({
	onResponseSubmitted,
	successMessage,
	data,
}: {
	onResponseSubmitted: (data: IEventSurveyResponse) => void;
	successMessage: string;
	data: IEventSurveyResponse;
}) => {
	toast.success(successMessage);
	onResponseSubmitted(data);
};

export const getRsvpBackground = (attending: boolean | null, IS_PAST_EVENT: boolean, EVENT_FULL: boolean): string => {
	if (attending && !IS_PAST_EVENT && !EVENT_FULL) return successTint;
	if (attending === false || IS_PAST_EVENT || EVENT_FULL) return pink2;
	return mention;
};
